module.exports = __webpack_public_path__ + "img/BIT_white16.6783f876.jpg";